<div class="row">
  <div class="col-lg-12">
    <jni-freight-quotation-form
      [partyNumber]="partyNumber"
      [saleOrderId]="saleOrderId"
      [purchaseSaleOrderId]="purchaseSaleOrderId"
      [accountNumber]="accountNumber"
      [jobName]="jobName"
      [selectedLineItems]="selectedLineItems"
      [quoteId]="quoteIdFromModal"
      (closeModalEvent)="onCloseModalEvent()"></jni-freight-quotation-form>
  </div>
</div>
